export default {
  common: {
    Add: '新增',
    AddRow: '添加',
    Verify: '审核',
    Export: '导出',
    Import: '导入',
    Search: '搜索',
    Reset: '重置',
    ResetPwd: '重置密码',
    OnLine: '上线',
    OffLine: '下线',
    Operate: '操作',
    Modify: '修改',
    Delete: '删除',
    UpLoad: '上传',
    DownLoad: '下载',
    Save: '保存',
    Cancel: '取消',
    Check: '查看',
    Sex: '性别',
    All: '全部',
    To: '至',
    OneWeek: '最近一周',
    OneMouth: '最近一个月',
    ThreeMouth: '最近三个月',
    Tips: '提示',
    Close: '停用',
    Disable: '停用',
    Copy: '复制',
    Recovery: '恢复',
    Draft: '草稿',
    Choose: '选择',
    Password: '密码',
    Ok: '确定',
    Y: '是',
    N: '否',
    PleaseChoose: '请选择',
    DeleteConfirm: '您确定要删除该记录吗？',
    RecoverConfirm: '您确定要恢复该记录吗?',
    DisableConfirm: '您确定要停用该记录吗?',
    DeleteCancelResult: '该操作已经取消！',
    Confirm: '确定',
    EnsureDelete: '是否删除该数据',
    UserRegistration: '用户注册',
    AdministratorAdd: '手动新增',
    FromBackEnd: '管理员新增',
    FromFrontEnd: '网站注册',
    Edit: '编辑',
    Normal: '正常',
    OnSale: '上架',
    NoSale: '下架',
    Publish: '发布',
    NoPublish: '未发布',
    No: '序号',
    Customize: '定制',
    Default: '默认',
    // 常规名称
    System: '系统',
    SystemName: '系统名称',
    Code: '编码',
    Name: '名称',
    Value: '值',
    Type: '类型',
    Remark: '备注',
    MaxWords: '最多90个汉字',
    Status: '状态',
    Valid: '是否有效',
    StartTime: '开始时间',
    EndTime: '结束时间',
    StartDay: '开始日期',
    EndDay: '结束日期',
    Regtime: '注册日期',
    ModifyUser: '修改用户',
    CreateTime: '创建日期',
    CheckPending: '待审核',
    ModifyTime: '修改日期',
    ModifyTimeDetail: '修改时间',
    NoData: '暂无数据',
    Refresh: '刷新',
    BasicInformation: '基本信息',
    AccountingInformation: '账号信息',
    FinancialInformation: '账务信息',
    BusinessInformation: '业务信息',
    AccountTips: '登录账号可以有数字、字符、下划线',
    DiscountTips: '默认为10无折扣(例如9.2折，填写9.2)',
    basicInformation: '基本信息',
    InvoiceInformation: '开票信息',
    TaxNo: '税号',
    Account: '账号',
    Pwd: '密码',
    UploadPicture: '上传图片',
    UploadQRCode: '上传个人微信二维码',
    PictureURLCanNotBeEmpty: '图片Url不能为空',
    DeleteTips: '请选择需要删除的数据',
    VerifyTips: '是否通过审核?',
    Approved: '通过',
    NotApproved: '不通过',
    // 产品相关
    ProductCode: '商品编码',
    ProductName: '商品名称',
    Quantity: '数量',
    Unit: '单位',
    RelatedProduct: '关联产品',
    Price: '价格',
    Province: '省',
    City: '市',
    Area: '区/县',
    Telephone: '电话号码',
    Man: '男',
    Woman: '女',
    Birthday: '生日',
    ZipCode: '邮编',
    Contacts: '联系人',
    Mobile: '联系电话',
    Tel: '电话',
    ComeFrom: '来源',
    RetailPrice: '零售价',
    FirstPrice: '一级批发价',
    SecondPrice: '二级批发价',
    ThirdPrice: '三级批发价',
    Fourth: '四级批发价',
    FifthPrice: '五级批发价',
    Address: '地址',
    SalesmenEmpty: '业务员不能为空',
    AgentEmpty: '代理商名称不能为空',
    NotEmpty: '不能为空',
    OverLength: '数据过长',
    CorrectAccountNumber: '请输入正确的账号',
    CorrectMobile: '请输入正确的电话号码',
    CorrectFormat: '请输入正确的格式',
    RegionEmpty: '区域不能为空',
    WechatCode: '微信编号',
    WechatName: '微信名称',
    RefereeCode: '加权编号',
    RefereeName: '加权名称',
    GoodsNo: '货号',
    AuditStatus: '审核状态'
  }
}



// WEBPACK FOOTER //
// ./src/i18n/lang/cn/common.js